@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.out-of-filter-body {
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

:global(.header-txt).out-of-filter-header {
  margin-top: 1.25em;
  margin-bottom: 0.75em;
  text-align: center;
  line-height: 33px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 1.5em;
  }
}

.out-of-filter-text {
  color: colors.$body-text;

  & > * {
    margin-bottom: 10px;
  }
}

// Flexpay

:global(.flexpay) {
  .out-of-filter-body {
    width: 100%;
  }

  :global(.header-txt).out-of-filter-header {
    text-align: left;
  }
}
